import React from 'react';
import Entry from '../../components/Entry';
import RawEntry from '../../components/entryconfigType';
import '../../Default.css';
import { Routes, Route } from "react-router-dom";
import SaintsRender from './SaintsRender';

import saints_file from "./saints.json"
import Saint from './saintsType';
const saints: Saint[] = saints_file as any;



const menuItems: RawEntry[] = saints.map((entry,index) =>
  {
    return {
      link: `./${index}`,
      text: entry.name
    } as RawEntry
  }
)


function SaintsMenu(){
  return (
    <>
        <div className="page-title">
        Patroni
        </div>
        <div className="navigation-wraper">
          <nav className='small-nav-bar navigation-bar'>
            {menuItems.map((v,i) => <Entry conf={v} key={i}/>)}
          </nav>
        </div>
        
    </>
  )
}

function Saints() {
    return (
      <>
          <Routes>
            <Route path='/' element={SaintsMenu()}></Route>
            {saints.map((entry,index) => 
              <Route path={`/${index}/*`} key={index.toString()} element={SaintsRender(entry)}/>
            )}
          </Routes>
      </>
    );
}

export default Saints;
